import { render, staticRenderFns } from "./FurnitureDesign.vue?vue&type=template&id=7dc0a5a2&scoped=true&"
import script from "./FurnitureDesign.vue?vue&type=script&lang=js&"
export * from "./FurnitureDesign.vue?vue&type=script&lang=js&"
import style0 from "./FurnitureDesign.vue?vue&type=style&index=0&id=7dc0a5a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc0a5a2",
  null
  
)

export default component.exports